module.exports = __webpack_public_path__ + "static/media/shoulders2.b5789a40.png";